import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import style from './style.module.scss';
const LABELS = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'];
export default function WeekdayPicker({ label, selected, onChange, weekStart = 1, }) {
    // Build display order: weekStart=0 means Sunday first
    const order = weekStart === 0
        ? [6, 0, 1, 2, 3, 4, 5]
        : [0, 1, 2, 3, 4, 5, 6];
    const toggle = (idx) => {
        const next = [...selected];
        next[idx] = !next[idx];
        onChange(next);
    };
    return (_jsxs("div", { className: style['weekday-picker'], children: [label && _jsx("label", { children: label }), _jsx("div", { className: style['weekday-grid'], children: order.map(idx => (_jsx("button", { type: "button", className: `${style['weekday-btn']}${selected[idx] ? ` ${style['selected']}` : ''}`, onClick: () => toggle(idx), children: LABELS[idx] }, idx))) })] }));
}
